import { render } from "./bids-sent.vue?vue&type=template&id=e83770e2&scoped=true"
import script from "./bids-sent.vue?vue&type=script&lang=js"
export * from "./bids-sent.vue?vue&type=script&lang=js"

import "./bids-sent.vue?vue&type=style&index=0&id=e83770e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83770e2"]])

export default __exports__